import { render, staticRenderFns } from "./PPEAction.vue?vue&type=template&id=4b529bf6&"
import script from "./PPEAction.vue?vue&type=script&lang=js&"
export * from "./PPEAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports